window.DRIVE_DASHBOARD = {
    options: {
        playbackDuration: 20000, // seconds it should take to draw a route.
        osrmServiceUrl: undefined,
        showRouteLines: true,
        showRouteDots: false,
    },
    init: function (options) {
        _.extend(window.DRIVE_DASHBOARD.options, options);
    }
}
